import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HasClaimDirective } from './has-claim.directive';
import { PipesModule } from './pipes/pipes.module';
import { DragDropDirective } from './directives/drag-drop.directive';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AddReminderSchedulerComponent } from './add-reminder-scheduler/add-reminder-scheduler.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from 'ng-pick-datetime-ex';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { QuantitiesUnitPricePipe } from './pipes/quantities-unitprice.pipe';
import { QuantitiesUnitPriceTaxPipe } from './pipes/quantities-unitprice-tax.pipe';
import { PurchaseOrderInvoiceComponent } from './purchase-order-invoice/purchase-order-invoice.component';
import { PaymentStatusPipe } from './pipes/purchase-order-paymentStatus.pipe';
import { SalesOrderInvoiceComponent } from './sales-order-invoice/sales-order-invoice.component';
import { InventorySourcePipe } from './pipes/inventory-source.pipe';
import { LangDirDirective } from './directives/lang-dire.directive';
import { PaymentModalComponent } from './payment-modal/payment-modal.component';
import { CCNumberMaskDirectiveModule } from './directives/cc-number-mask.directive';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OnlynumberDirective } from './directives/onlynumber.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SendEmailModalComponent } from './send-email-modal/send-email-modal.component';
import { ReadonlyObserverDirective } from './directives/readonly.directive';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { PrintLabelModalComponent } from './print-label-modal/print-label-modal.component';
import { GenerateBarcodeComponent } from './generate-barcode/generate-barcode.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { QRCodeModule } from 'angularx-qrcode';
import { TrimDirective } from '@core/services/custom-validator.service';
import { StripeconnectPaymentModule } from './stripeconnect-payment/stripeconnect-payment.component';
import { RemoveSignsPipe } from './pipes/remove-signs.pipe';

@NgModule({
  exports: [
    HasClaimDirective,
    PipesModule,
    TranslateModule,
    DragDropDirective,
    OverlayModule,
    QuantitiesUnitPricePipe,
    QuantitiesUnitPriceTaxPipe,
    PurchaseOrderInvoiceComponent,
    SalesOrderInvoiceComponent,
    PaymentStatusPipe,
    InventorySourcePipe,
    LangDirDirective,
    PaymentModalComponent,
    SendEmailModalComponent,
    ReadonlyObserverDirective,
    FileUploaderComponent,
    PrintLabelModalComponent,
    GenerateBarcodeComponent,
    TrimDirective,
    RemoveSignsPipe
  ],
  imports: [
    CommonModule,
    PipesModule,
    OverlayModule,
    NgxDocViewerModule,
    NgxExtendedPdfViewerModule,
    MatIconModule,
    TranslateModule,
    MatDialogModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTableModule,
    CCNumberMaskDirectiveModule,
    MatInputModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    NgxBarcodeModule,
    QRCodeModule,
    StripeconnectPaymentModule
  ],
  providers: [BsModalService],
  declarations: [
    HasClaimDirective,
    DragDropDirective,
    AddReminderSchedulerComponent,
    QuantitiesUnitPricePipe,
    QuantitiesUnitPriceTaxPipe,
    PurchaseOrderInvoiceComponent,
    SalesOrderInvoiceComponent,
    PaymentStatusPipe,
    InventorySourcePipe,
    LangDirDirective,
    PaymentModalComponent,
    OnlynumberDirective,
    SendEmailModalComponent,
    ReadonlyObserverDirective,
    FileUploaderComponent,
    PrintLabelModalComponent,
    GenerateBarcodeComponent,
    TrimDirective,
    RemoveSignsPipe
  ],
})
export class SharedModule {}
